/**
 * Backend dashboard endpoints return action strings (e.g. `/admin/cobranza?tab=recordatorios`)
 * that don't always map 1:1 to the real client routes. This helper normalizes them.
 */
export function resolveDashboardAction(action: string): string {
  if (!action) return '/admin-v2';
  if (action.startsWith('/admin/cobranza')) {
    if (action.includes('recordatorios')) return '/admin/routines';
    return '/admin/finanzas';
  }
  if (action.startsWith('/admin/avisos')) return '/admin/comunicados';
  if (action.startsWith('/admin/tickets')) return '/incidentes';
  return action;
}
